// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"c4221241","488":"ea86f422","668":"f94f6e36","787":"128fc6e9","990":"6de86981"}[chunkId] + ".chunk.js";
};